import { AiFillStar } from "react-icons/ai";
import { useTranslation } from "react-i18next";

export const Testimonial = ({
  name,
  rating,
  content,
  content1,
  profession,
  imgSrc,
  linkedInUrl,
  showHiddenText,
  toggleText,
}) => {
  const { t } = useTranslation();

  const renderStars = (rating) => {
    const starsArray = Array.from({ length: rating }, (_, index) => (
      <AiFillStar key={index} />
    ));
    return starsArray;
  };

  return (
    <a
      className="slider-wrapper"
      target="_blank"
      href="/"
      rel="noreferrer"
      aria-label="David LinkedIn profile and review"
      onClick={(e) => e.preventDefault()}
      style={{ cursor: "auto" }}
    >
      <div className="main carousel-section">
        <div className="carousel-images d-flex">
          <div className="first-image">
            <div className="second-group">
              <div
                onClick={() => window.open(linkedInUrl, "_blank")}
                style={{ cursor: "pointer" }}
              >
                <div className="image-group rounded-circle">
                  <img
                    src={imgSrc}
                    alt="David"
                    className="img-fluid rounded-circle"
                    loading="lazy"
                  />
                </div>
                <div className="details">
                  <span className="name">{name}</span>
                  <div className="stars">
                    {renderStars(rating)}
                    <span>5/5</span>
                  </div>
                </div>
              </div>
              <p className="mb-0">
                {t(content)}
                <span className={showHiddenText ? "" : "hidden-text"}>
                  {t(content1)}
                </span>
                <span
                  className="show_more"
                  onClick={(e) => toggleText(e)}
                  style={{ cursor: "pointer" }}
                >
                  {showHiddenText ? t("Show less") : t("Show more")}
                </span>
              </p>
            </div>
            <div className="purple">
              <p className="text-center mb-0 discover_para">{t(profession)}</p>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};
